import { Component } from 'react';
import PropTypes from 'prop-types';
import ImPropTypes from 'react-immutable-proptypes';
import Im from 'immutable';
import cn from 'classnames';

import { ReactComponent as ArrowIcon } from '../../../../src/styles/icon/downArrowNew.svg';
import model from './ModelCollapse.module.scss';

export default class ModelCollapse extends Component {
  static propTypes = {
    collapsedContent: PropTypes.any,
    expanded: PropTypes.bool,
    children: PropTypes.any,
    title: PropTypes.element,
    modelName: PropTypes.string,
    classes: PropTypes.string,
    onToggle: PropTypes.func,
    hideSelfOnExpand: PropTypes.bool,
    layoutActions: PropTypes.object,
    layoutSelectors: PropTypes.object.isRequired,
    specPath: ImPropTypes.list.isRequired,
    modelType: PropTypes.string
  };

  static defaultProps = {
    collapsedContent: '{...}',
    expanded: false,
    title: null,
    onToggle: () => {},
    hideSelfOnExpand: false,
    specPath: Im.List([]),
    hideToggle: false,
    modelType: ''
  };

  constructor(props, context) {
    super(props, context);

    let { expanded, collapsedContent } = this.props;

    this.state = {
      expanded: expanded,
      collapsedContent: collapsedContent || ModelCollapse.defaultProps.collapsedContent,
    };
  }

  componentDidMount() {
    const { hideSelfOnExpand, expanded, modelName } = this.props;
    if (hideSelfOnExpand && expanded) {
      // We just mounted pre-expanded, and we won't be going back..
      // So let's give our parent an `onToggle` call..
      // Since otherwise it will never be called.
      this.props.onToggle(modelName, expanded);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.expanded !== nextProps.expanded) {
      this.setState({ expanded: nextProps.expanded });
    }
  }

  toggleCollapsed = () => {
    if (this.props.onToggle) {
      this.props.onToggle(this.props.modelName, !this.state.expanded);
    }

    this.setState({
      expanded: !this.state.expanded,
    });
  };

  onLoad = (ref) => {
    if (ref && this.props.layoutSelectors) {
      const scrollToKey = this.props.layoutSelectors.getScrollToKey();

      if (Im.is(scrollToKey, this.props.specPath)) this.toggleCollapsed();
      this.props.layoutActions.readyToScroll(this.props.specPath, ref.parentElement);
    }
  };

  render() {
    const { title, classes, mainSchema, hideToggle, modelType } = this.props;

    if (this.state.expanded) {
      if (this.props.hideSelfOnExpand) {
        return <span className={classes || ''}>{this.props.children}</span>;
      }
    }

    return (
      <div
        className={cn(classes, {
          [model.model__container]: mainSchema,
        })}
        ref={this.onLoad}
      >
        {!hideToggle && (
          <button
            aria-expanded={this.state.expanded}
            className={cn(model.model__box, {
              [model.model__box__main]: mainSchema,
              [model.model__box__enum]: modelType == 'enum'
            })}
            onClick={this.toggleCollapsed}
          >
            {title && (
              <span className="pointer">
                <span className={cn({ [model.model__title]: mainSchema })}>{title}</span>
              </span>
            )}
            {!title && modelType == 'enum' && (
              <div
                className={model.model__modelType}
              >
                Enum:
              </div>
            )}
            {/* <span className={'model-toggle' + (this.state.expanded ? '' : ' collapsed')}></span> */}
            <div
              className={cn(model.model__icon__wrapper, {
                [model.model__icon__wrapper__main]: mainSchema,
              })}
            >
              <ArrowIcon
                className={cn({
                  [model.model__icon]: !mainSchema,
                  [model.model__icon__expanded]: !mainSchema && this.state.expanded,
                  [model.model__icon__main]: mainSchema,
                  [model.model__icon__main__expanded]: mainSchema && this.state.expanded,
                })}
              />
            </div>

            {/* {!this.state.expanded && <span>{this.state.collapsedContent}</span>} */}
          </button>
        )}

        {this.state.expanded && this.props.children}
      </div>
    );
  }
}
